const PaymentIcon = () => {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="17"
        height="14"
        viewBox="0 0 17 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.125 2V12C1.125 12.3315 1.2567 12.6495 1.49112 12.8839C1.72554 13.1183 2.04348 13.25 2.375 13.25H14.875C15.0408 13.25 15.1997 13.1842 15.3169 13.0669C15.4342 12.9497 15.5 12.7908 15.5 12.625V3.875C15.5 3.70924 15.4342 3.55027 15.3169 3.43306C15.1997 3.31585 15.0408 3.25 14.875 3.25H2.375C2.04348 3.25 1.72554 3.1183 1.49112 2.88388C1.2567 2.64946 1.125 2.33152 1.125 2ZM1.125 2C1.125 1.66848 1.2567 1.35054 1.49112 1.11612C1.72554 0.881696 2.04348 0.75 2.375 0.75H13"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0625 9.1875C12.5803 9.1875 13 8.76777 13 8.25C13 7.73223 12.5803 7.3125 12.0625 7.3125C11.5447 7.3125 11.125 7.73223 11.125 8.25C11.125 8.76777 11.5447 9.1875 12.0625 9.1875Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

export default PaymentIcon;
